import Helpers from '../../common/helpers/Helpers';
import Constants from '../../common/constants/Constants';

export const getInstrumentDetails = id => {
  return Helpers.get(`${Constants.INSTRUMENTS_URL}/${id}`);
};
